import React, { useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Button from '@material-ui/core/Button';
import Slider from '@material-ui/core/Slider';
import Checkbox from '@material-ui/core/Checkbox';
import ColorPickerComp from './ColorPickerComp';
import CategoriesFilterComp from './CategoriesFilterComp';
import AppContext from '../../../contexts/AppContext';
import Divider from '@material-ui/core/Divider';
import { isIOS } from 'react-device-detect';
import htmlParse from 'react-html-parser';
import './ImageFilterComp.css';

const useStyles = makeStyles((theme) => ({
  header: {
    marginTop: theme.spacing(2),
  },
  divider: {
    marginTop: theme.spacing(2),
    width: '100%',
  },

  formGroup: {
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
    width: '100%',
  },
  typeLabel: {
    width: '100%',
    marginBottom: '20px',
    marginTop: '20px',
  },
  control: {
    width: '100%',
  },
  checkboxLabel: {
    marginLeft: '20px',
  },
  unLink: {
    fontSize: '10px',
  },
}));

export default function ImageFilterComp(props) {
  const classes = useStyles();
  const { dictionnary, axl } = useContext(AppContext);

  const onClickLinkHandler = (url) => {
    if (axl) {
      const AxL = require('../../../utils/Axl').default;
      axl.sendMessage(AxL.ChildToHost.NAVIGATE, url);

      return;
    }
  };

  const [ratioFilter, setRatioFiler] = React.useState({
    landscape: true,
    portrait: true,
    unCurated: true,
    agora: true,
    gac: true,
  });

  const [dateRange, setDateRange] = React.useState([1700, 2020]);
  const handleDateRangeChanged = (event, newValue) => {
    setDateRange(newValue);
  };

  const handleRatioChange = (event) => {
    const filter = {
      ...ratioFilter,
      [event.target.name]: event.target.checked,
    };
    setRatioFiler(filter);
    props.onLandscapeChanged(filter);
  };

  const handleUNCuratedChange = (event) => {
    const filter = {
      ...ratioFilter,
      [event.target.name]: event.target.checked,
    };
    setRatioFiler(filter);
    props.onCuratedChanged(filter);
  };

  const handleAgoraCollection = (event) => {
    const filter = {
      ...ratioFilter,
      [event.target.name]: event.target.checked,
    };
    setRatioFiler(filter);
    props.onAgoraCollectionChanged(filter);
  };

  const handleGacCollection = (event) => {
    const filter = {
      ...ratioFilter,
      [event.target.name]: event.target.checked,
    };
    setRatioFiler(filter);
    props.onGacCollectionChanged(filter);
  };

  const handleCategoriesChanged = (categories) => {
    if (props.onCategoriesChanged) {
      props.onCategoriesChanged(categories);
    }
  };

  const landscapeTxt = dictionnary.get('edit-landscape');
  const portraitTxt = dictionnary.get('edit-portrait');

  return (
    <>
      <Typography component="p" className={'edit-header'}>
        {htmlParse(dictionnary.get('edit-header'))}
      </Typography>
      <Divider className={classes.header} variant="middle" />

      <div className={classes.header}>
        {false && (
          <Typography variant="h6" component="h6">
            {dictionnary.get('edit-filter-title')}
          </Typography>
        )}
      </div>
      <Typography className={classes.typeLabel} variant="h6" component="h6">
        {dictionnary.get('edit-filter-format')}
      </Typography>
      <FormGroup row className={classes.formGroup}>
        <div className={classes.control}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={ratioFilter.landscape}
                  onChange={handleRatioChange}
                  name="landscape"
                  color="primary"
                  style={{
                    marginRight: '10px',
                  }}
                />
              }
              label={
                ratioFilter.landscape ? <b>{landscapeTxt}</b> : landscapeTxt
              }
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={ratioFilter.portrait}
                  onChange={handleRatioChange}
                  name="portrait"
                  color="primary"
                  style={{
                    marginRight: '10px',
                  }}
                />
              }
              label={ratioFilter.portrait ? <b>{portraitTxt}</b> : portraitTxt}
            />
          </FormGroup>
        </div>
        <Divider className={classes.divider} variant="middle" />
        <Typography className={classes.typeLabel} variant="h6" component="h6">
          {dictionnary.get('edit-filter-type')}
        </Typography>
        <div className={classes.control}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={ratioFilter.unCurated}
                  onChange={handleUNCuratedChange}
                  name="unCurated"
                  color="primary"
                  style={{
                    marginRight: '10px',
                  }}
                />
              }
              label={
                ratioFilter.unCurated ? (
                  <b>{dictionnary.get('edit-filter-future')}</b>
                ) : (
                  dictionnary.get('edit-filter-future')
                )
              }
            />
          </FormGroup>
        </div>
        <div className={classes.control}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={ratioFilter.agora}
                  onChange={handleAgoraCollection}
                  name="agora"
                  color="primary"
                  style={{
                    marginRight: '10px',
                  }}
                />
              }
              label={
                ratioFilter.agora ? (
                  <b>{dictionnary.get('edit-filter-agora')}</b>
                ) : (
                  dictionnary.get('edit-filter-agora')
                )
              }
            />
          </FormGroup>
        </div>
        <div className={classes.control}>
          <FormGroup row>
            <FormControlLabel
              control={
                <Checkbox
                  checked={ratioFilter.gac}
                  onChange={handleGacCollection}
                  name="gac"
                  color="primary"
                  style={{
                    marginRight: '10px',
                  }}
                />
              }
              label={
                ratioFilter.gac ? (
                  <b>{dictionnary.get('edit-filter-gac')}</b>
                ) : (
                  dictionnary.get('edit-filter-gac')
                )
              }
            />
          </FormGroup>
        </div>
        <Divider className={classes.divider} variant="middle" />

        <Typography className={classes.typeLabel} variant="h6" component="h6">
          {dictionnary.get('edit-filter-theme')}
        </Typography>
        <FormGroup row className={'edit-category-container'}>
          <CategoriesFilterComp
            categories={props.categories}
            onCategoryChanged={(categories) =>
              handleCategoriesChanged(categories)
            }
          ></CategoriesFilterComp>
        </FormGroup>

        {false && (
          <>
            <Typography
              className={classes.typeLabel}
              variant="h6"
              component="h6"
            >
              Colour
            </Typography>
            <ColorPickerComp
              onColorChangeHandler={props.onColorChangeHandler}
            />
            <Typography
              className={classes.typeLabel}
              variant="h6"
              component="h6"
            >
              Date of creation
            </Typography>
            <Slider
              value={dateRange}
              onChange={(event, newValue) => {
                handleDateRangeChanged(event, newValue);
              }}
              onChangeCommitted={(event, newValue) => {
                if (props.onDataRangeChanged) {
                  props.onDataRangeChanged(newValue);
                }
              }}
              valueLabelDisplay="auto"
              aria-labelledby="range-slider"
              min={1700}
              max={2020}
              step={10}
            />
          </>
        )}

        {!isIOS && (
          <button
            className="btn-link small"
            onClick={() => {
              onClickLinkHandler(dictionnary.get('edit-ungoals-link'));
            }}
          >
            {dictionnary.get('edit-ungoals-txt')}
          </button>
        )}

        <Button
          size="small"
          variant="contained"
          color="primary"
          className={classes.formGroup}
          onClick={() => {
            props.onRandomize();
          }}
        >
          {dictionnary.get('edit-filter-randomize')}
        </Button>
        {props.nImages > 0 && (
          <Typography variant="caption">
            {props.nImages} {dictionnary.get('edit-filter-found')}
          </Typography>
        )}
        {props.nImages === 0 && (
          <Typography variant="body">
            {props.nImages} {dictionnary.get('edit-filter-found')}
          </Typography>
        )}
      </FormGroup>
    </>
  );
}
